<template>
  <div class="signin_enter">
    <div class="face_box_qrcode" v-if="attendType.indexOf('3') > -1">
      <img class="qrcode_img" :src="qrCodeImgUrl" alt="">
    </div>
    <div v-else class="face_box">
      <p v-if="attendType.indexOf('2') > -1" class="face_text">摄像头实时拍摄的人脸画面</p>
      <div v-else class="jsk_state">
        <p class="qsk_text">请刷卡</p>
        <img src="../../../../../public/img/product/bootScreen/img-swipe.png" />
      </div>
    </div>
    <div class="signin_state">
      <div class="head_img">
        <van-image class="header_mainimg" v-if="attendInfo.errorCode && attendInfo.errorCode < 30004" lazy-load :src="attendInfo.photo | imgFormat">
          <template v-slot:loading>
            <van-loading type="spinner" size="20" />
          </template>
          <template v-slot:error>
            <img class="header_errorimg" :src="defaultImg"/>
          </template>
        </van-image>
        <img v-else :src="defaultImg"/>
      </div>
      <div class="state_box">
        <div v-if="attendInfo.errorCode == 30001">
          <p class="succe">签到成功</p>
          <p class="name">{{ attendInfo.name }}</p>
        </div>
        <div v-else-if="attendInfo.errorCode == 30002">
          <p class="error">重复签到</p>
          <p class="name">{{ attendInfo.name }}</p>
        </div>
        <div v-else-if="attendInfo.errorCode == 30003">
          <p class="error">重复签退</p>
          <p class="name">{{ attendInfo.name }}</p>
        </div>
        <div v-else-if="attendInfo.errorCode == 30005">
          <p class="error">无效卡</p>
        </div>
        <span v-else class="wqd">请你人脸识别签到或刷卡签到！</span>
      </div>
    </div>
    <van-dialog
      v-model="show"
      :show-confirm-button="false"
      closeOnClickOverlay
      :show-cancel-button="false"
      width="85%"
    >
      <div class="dialog-signin-maindiv" @click="show = false">
        <div class="dialog-closebuttondiv">点击任意处关闭</div>
        <div class="dialog-closebutton iconfont icon-icon_wrong" @click="show = false"></div>
        <div class="dialog-maininfo">
          <div class="maininfo_mess">
            <div class="maininfo_mess_imgcontent">
              <img src="../../../../../public/img/product/bootScreen/icon-alert.png"/>
            </div>
            <p class="go_place">
              {{ attendInfo.name || "" }}学员<br>请您前往<span>{{ addressInfo.place || "" }}</span
              >签到！
            </p>
            <p class="now_place">当前位置：{{ currentAddress || "" }}</p>
          </div>
          <div class="course_mess">
            <p class="course_title">您的课程信息如下：</p>
            <div class="course_item">
              <p class="course_label iconfont icon-rili"></p>
              <p class="course_val">{{ dsf.date.format(addressInfo.beginDateTime, "mm月dd日 hh:ii")}}</p>
            </div>
            <div class="course_item">
              <p class="course_label iconfont icon-address"></p>
              <p class="course_val">{{ addressInfo.place || "" }}</p>
            </div>
            <div class="course_item">
              <p class="course_label iconfont icon-xxkc"></p>
              <p class="course_val">
                {{ addressInfo.name || "" }}
              </p>
            </div>
            <div class="course_item">
              <p class="course_label iconfont icon-jiaoshi"></p>
              <p class="course_val">{{ addressInfo.speakerText || "" }}</p>
            </div>
          </div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
// 签到情况
export default {
  data() {
    return {
      defaultImg: require("../../../../../public/img/product/bootScreen/headSculpture.png"),
      show: false,
      qrCodeImgUrl: "",
      timer: null,
      clearSignInfoTimer: null,
    };
  },
  props:{
    attendType: {
      type: String,
      default: "",
    },
    currentAddress: {
      type: String,
      default: "",
    },
    attendInfo: {
      type: Object,
      default: () => {},
    },
    addressInfo: {
      type: Object,
      default: () => {},
    },
  },
  watch:{
    'attendInfo': function(newVal , oldVal){
      if(!dsf.isEmptyObject(newVal)){
        let _this = this;
        if(newVal.errorCode == 30004){
        if(this.clearSignInfoTimer){
          clearTimeout(this.clearSignInfoTimer);
        }
        this.show = true;
        this.clearSignInfoTimer = setTimeout(() => {
          _this.$emit("update:attendInfo" , {});
          _this.show = false;
        }, 10000);
      }else{
        if(this.timer){
          clearTimeout(this.timer);
        }
        let timeCount = parseInt(dsf.config.setting_screen_photo_show_time) * 1000;
        this.timer = setTimeout(() => {
          _this.$emit("update:attendInfo" , {});
        }, timeCount);
      }
      }
    }
  },
  mounted() {
    let equipmentId = sessionStorage.getItem("equipmentId") || "";
    this.qrCodeImgUrl = "teas/screen/generateQrCode?id=" + this.$route.query.id + "&relId=" +  this.$route.query.relId + "&attendMode=" + this.$route.query.attendMode + "&type=" + this.$route.query.type + "&equipmentId=" + equipmentId + "&t=" + new Date().getTime(); 
  },
  methods: {
    refreshQrCodeFunction() {
      let equipmentId = sessionStorage.getItem("equipmentId") || "";
      this.qrCodeImgUrl = "teas/screen/generateQrCode?id=" + this.$route.query.id + "&relId=" +  this.$route.query.relId + "&attendMode=" + this.$route.query.attendMode + "&type=" + this.$route.query.type + "&equipmentId=" + equipmentId + "&t=" + new Date().getTime(); 
    },
  },
};
</script>
